import { getApiUrl } from '@/config/api'

// URL builders for the notification bell endpoints (ENG-3380).
//
// Builders rather than fetchers, matching `coachMessagesService`: the caller
// pairs the URL with `createFetcher` / `createSubmitter` from `@/services/api`,
// so the URL doubles as the SWR cache key.
//
// The count has its own key on purpose. It is polled on every page and the list
// is fetched only when somebody opens the panel, so sharing a key would mean
// either polling the list too or letting the badge go stale.

import type { NotificationCursor } from '@/types/notifications'

export const notificationsService = {
  /** The badge number. Scoped to the caller, so it takes no id. */
  getUnreadCountUrl: () => getApiUrl('/notifications/unread-count'),

  /** One page, newest first. */
  getNotificationsUrl: (limit: number, before?: NotificationCursor | null) => {
    const params = new URLSearchParams({ limit: String(limit) })
    if (before) {
      params.set('before_created_at', before.created_at)
      params.set('before_id', before.id)
    }
    return getApiUrl(`/notifications?${params.toString()}`)
  },

  getMarkReadUrl: () => getApiUrl('/notifications/read'),
}
